/**
 * Created by bas.
 */

'use strict';

var gettextWrapper      = require('mag-gettext'),
    savers              = [],
    saversByPackageName = {},
    packageNameToPath   = {},
    currentInterval, currentSaverPackageName, currentSaverPackage, gettext;

function init ( config ) {
    var packages, packageName, packageInfo;

    // apply interval settings
    currentInterval = Number(config.storage.getItem('timeValue'));
    if ( !currentInterval && currentInterval !== 0 ) {
        // default time 5 minutes
        currentInterval = 300;
        config.storage.setItem('timeValue', currentInterval);
    }
    if ( DEVELOP ) {
        console.log(currentInterval ? 'screen saver interval ' + currentInterval : 'screen saver turned off');
    }
    gSTB.SetScreenSaverTime(currentInterval);

    // activate selected screen saver view
    currentSaverPackageName = config.storage.getItem('saverName');
    packages = core.packageMap;

    for ( packageName in packages ) {
        if ( packages.hasOwnProperty(packageName) && packages[packageName].type && packages[packageName].type === 'screen-saver' ) {
            packageInfo = {
                name:        core.packageMap[packageName].name,
                path:        core.packageMap[packageName].url,
                packageName: core.packageMap[packageName].packageName
            };
            if ( DEVELOP ) {
                console.log('Screen saver package found:');
                console.log('name ' + packageInfo.name);
                console.log('path ' + packageInfo.path);
            }
            savers.push(packageInfo);
            saversByPackageName[packageInfo.packageName] = packageInfo;
            packageNameToPath[core.packageMap[packageName].packageName] = packageInfo.path;
            if ( currentSaverPackageName === packageInfo.packageName ) {
                currentSaverPackage = packageInfo;
            }
        }
    }
    // current screen saver not found in list - use first one
    if ( !currentSaverPackageName && savers[0] ) {
        if ( DEVELOP ) {
            console.log('selected screen saver package not found, use first one: ' + savers[0].packageName);
        }
        currentSaverPackageName = savers[0].packageName;
        currentSaverPackage = savers[0];
        config.storage.setItem('saverName', currentSaverPackageName);
    }

    if ( currentSaverPackageName ) {
        if ( DEVELOP ) {
            console.log('set screen saver path to: ' + packageNameToPath[currentSaverPackageName]);
        }
        gSTB.SetScreenSaverInitAttr(JSON.stringify({
            url: packageNameToPath[currentSaverPackageName],
            backgroundColor: '#000'
        }));
    } else {
        // can't find any screen saver, turn off
        if ( DEVELOP ) {
            console.log('none screen saver package was found, turn off');
        }
        gSTB.SetScreenSaverTime(0);
    }
}


function build ( config ) {
    var timeToLabel = {
            0:    gettext('Disabled'),
            60:   gettext('1 minute'),
            300:  gettext('5 minutes'),
            600:  gettext('10 minutes'),
            1200: gettext('20 minutes'),
            1800: gettext('30 minutes')
        },
        result;

    if ( currentSaverPackageName ) {
        result = {
            content: [
                {
                    id: 'screenSaverInterval',
                    parent: 'userInterface',
                    type: 'option',
                    name: gettext('Screensaver interval'),
                    description: [
                        {
                            label: gettext('Interval') + ':',
                            value: timeToLabel[currentInterval] || ''
                        }, {
                            label: '',
                            value: gettext('The duration of the device inactivity, upon which appears the screensaver')
                        }
                    ],
                    icon: 'theme-icon-screensaver-interval',
                    data: {timeValue: 300},
                    saveImmediate: true,
                    render: config.api.renders.popupSelect,
                    prepareForRender: function ( data, callback ) {
                        callback(
                            [0, 60, 300, 600, 1200, 1800].map(function ( item ) {
                                return {value: item, name: timeToLabel[item], selected: currentInterval === item};
                            })
                        );
                    },
                    prepareForSave: function ( value, callback ) {
                        if ( DEVELOP ) {
                            console.log('interval changed, was ' + config.storage.getItem('timeValue') + ' set to ' + value);
                        }
                        currentInterval = value;
                        this.data.timeValue = currentInterval;
                        gSTB.SetScreenSaverTime(currentInterval);
                        callback(null, function () {
                            config.api.actions.setInfo({
                                description: [
                                    {
                                        label: gettext('Interval') + ':',
                                        value: timeToLabel[currentInterval] || ''
                                    }, {
                                        label: '',
                                        value: gettext('The duration of the device inactivity, upon which appears the screensaver')
                                    }
                                ]
                            });
                            if ( result && result.content && result.content[0] && result.content[0].description ) {
                                result.content[0].description[0].value = timeToLabel[currentInterval] || '';
                            }
                        });
                    }
                },
                {
                    id: 'screenSaverSelect',
                    parent: 'userInterface',
                    type: 'option',
                    name: gettext('Screensaver'),
                    description: [
                        {
                            label: gettext('Name') + ':',
                            value: currentSaverPackage.name
                        }, {
                            label: '',
                            value: gettext('Choosing a splash Screensaver')
                        }
                    ],
                    icon: 'theme-icon-screensaver',
                    data: {saverName: ''},
                    saveImmediate: true,
                    render: config.api.renders.popupSelect,
                    prepareForRender: function ( data, callback ) {
                        var items = [];

                        savers.forEach(function ( item ) {
                            items.push({
                                value:    item.packageName,
                                name:     item.name,
                                selected: item.packageName === currentSaverPackageName
                            });
                        });
                        callback(items);
                    },
                    prepareForSave: function ( value, callback ) {
                        if ( DEVELOP ) {
                            console.log('package changed, was ' + config.storage.getItem('saverName') + ', set to ' + value);
                            console.log('saversByName: ' + JSON.stringify(saversByPackageName));
                        }
                        currentSaverPackageName = saversByPackageName[value].packageName;
                        currentSaverPackage = saversByPackageName[value];
                        this.data.saverName = currentSaverPackageName;
                        gSTB.SetScreenSaverInitAttr(JSON.stringify({
                            url: packageNameToPath[currentSaverPackageName],
                            backgroundColor: '#000'
                        }));
                        callback(null, function () {
                            config.api.actions.setInfo({
                                description: [
                                    {label: gettext('Name') + ':', value: currentSaverPackage.name},
                                    {label: '', value: gettext('Choosing a splash Screensaver')}
                                ]
                            });
                            if ( result && result.content && result.content[1] && result.content[1].description ) {
                                result.content[1].description[0].value = currentSaverPackage.name;
                            }
                        });
                    }
                }
            ]
        };
    } else {
        result = {content: []};
        if ( DEVELOP ) {
            console.log('can\'t find any screen saver package! Hiding screen saver settings.');
        }
    }

    return result;
}


module.exports = {
    onInit: function ( config, callback ) {
        gettextWrapper.load({
            name: core.environment.language,
            path: config.path + 'lang'
        }, function () {
            gettext = gettextWrapper.gettext;
            init(config);
            callback();
        });
    },
    onAppInit: function ( config, callback ) {
        callback(null, {});
    },
    onSettingsInit: function ( config, callback ) {
        callback(null, build(config));
    }
};
